"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _head2 = _interopRequireDefault(require("lodash/head"));

var _reduxActions = require("redux-actions");

var _experimentActionKeys = _interopRequireDefault(require("./experimentActionKeys"));

var _targetService = _interopRequireDefault(require("./targetService"));

var _createActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var _default = (0, _reduxActions.createActions)((_createActions = {}, (0, _defineProperty2.default)(_createActions, _experimentActionKeys.default.GET_TARGET_OFFER, [function (name) {
  return {
    promise: _targetService.default.getTargetOffer(name)
  };
}, function (name) {
  return {
    name: name
  };
}]), (0, _defineProperty2.default)(_createActions, _experimentActionKeys.default.VARIATION_DETERMINED, function (targetDetails) {
  var responseTokens = (0, _head2.default)(targetDetails.responseTokens);
  var expAndVarInfo = responseTokens ? {
    experiment: {
      id: responseTokens['activity.id'],
      name: responseTokens['activity.name']
    },
    variation: {
      id: responseTokens['experience.id'],
      name: responseTokens['experience.name']
    },
    option: {
      id: responseTokens['option.id'],
      name: responseTokens['option.name']
    },
    profile: {
      activeActivities: responseTokens['profile.activeActivities'].split(','),
      daysSinceLastVisit: responseTokens['profile.daysSinceLastVisit'],
      isFirstSession: responseTokens['profile.isFirstSession'],
      isNewSession: responseTokens['profile.isNewSession']
    },
    geo: {
      zip: responseTokens['geo.zip']
    }
  } : {};
  return _objectSpread({
    key: targetDetails.mbox,
    session: {
      id: targetDetails.tracking.sessionId
    }
  }, expAndVarInfo);
}), _createActions));

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/experiment/v2/experimentActions.js
// module id = 3961
// module chunks = 25